import React, { useState } from "react";
import { withApollo } from "react-apollo";
import queries from "../../../queries";

// Adding, moving and removing the days of an Agenda 2.0 cell, whenever needed (not only through the CSV import).
// Kept apart from the events so the events list stays short.

const dayLabel = (day) => {
  const [year, month, date] = day.date.slice(0, 10).split('-');
  return `${date}.${month}.${year}`;
};

function Agendas2DaysEditor({ cell, refetch, client }) {
  const days = [...cell.days].sort((a, b) => a.date.localeCompare(b.date));
  const [pickedDay, setPickedDay] = useState(null);
  const [newDate, setNewDate] = useState('');
  const [dayDate, setDayDate] = useState(null); // edited date of the selected day (null = unchanged)
  const [state, setState] = useState('');

  const dayId = days.some((d) => d.id === pickedDay) ? pickedDay : (days[0] && days[0].id);
  const day = days.find((d) => d.id === dayId);
  const currentDate = day ? day.date.slice(0, 10) : '';
  const shownDate = dayDate === null ? currentDate : dayDate;

  const run = async (action) => {
    setState('…');
    try {
      await action();
      setState('');
    } catch (error) {
      setState('Erreur : ' + error.message);
    }
  };

  const add = () => run(async () => {
    const result = await client.mutate({ mutation: queries.cells.agendas2.addDay, variables: { input: { cell_id: cell.id, date: newDate } } });
    await refetch();
    setPickedDay(result.data.addAgendaDay.id);
    setDayDate(null);
    setNewDate('');
  });

  const move = () => run(async () => {
    await client.mutate({ mutation: queries.cells.agendas2.updateDayDate, variables: { id: day.id, date: shownDate } });
    await refetch();
    setDayDate(null);
  });

  const remove = () => run(async () => {
    await client.mutate({ mutation: queries.cells.agendas2.deleteDay, variables: { id: day.id } });
    await refetch();
    setPickedDay(null);
    setDayDate(null);
  });

  return (
    <div>
      <div className="tsk-input-line">
        <label>Nouveau jour</label>
        <input type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)} />
        <button type="button" className="tsk-button" disabled={!newDate} onClick={add}>Ajouter ce jour</button>
      </div>
      {day
        ? (
          <>
            <div className="tsk-input-line">
              <label>Jour à modifier</label>
              <select value={dayId} onChange={(e) => { setPickedDay(e.target.value); setDayDate(null); }}>
                {days.map((d) => <option key={d.id} value={d.id}>{dayLabel(d)}</option>)}
              </select>
            </div>
            <div className="tsk-input-line">
              <label>Nouvelle date</label>
              <input type="date" value={shownDate} onChange={(e) => setDayDate(e.target.value)} />
              <button type="button" className="tsk-button" disabled={!shownDate || shownDate === currentDate} onClick={move}>
                Changer la date
              </button>
            </div>
            <div className="tsk-input-line">
              <label>Suppression</label>
              <button
                type="button" className="tsk-button"
                onClick={() => { if (window.confirm('Supprimer ce jour et tous ses évènements ?')) remove(); }}
              >
                Supprimer ce jour
              </button>
            </div>
          </>
        )
        : <p>Aucun jour pour l'instant.</p>}
      {state && <p>{state}</p>}
    </div>
  );
}

export default withApollo(Agendas2DaysEditor);
